<form [formGroup]="form">
  <div class="row gy-2" [hidden]="isAdvanced">
    @if (options.filterFields.length > 0) {
      <div class="col-auto">
        <div class="row col-lg-auto col-md-12">
          <div class="col-lg-auto col-md-12 g-2">
            <label class="visually-hidden" for="filterFormType">Type</label>
            <select
              type="text"
              class="form-select form-select-sm me-2"
              name="filterField"
              placeholder="Select Field"
              data-cy="filterField"
              formControlName="filterField">
              @for (fld of options.filterFields; track fld) {
                <option [attr.data-cy]="fld.label" [ngValue]="fld">
                  {{ fld.label }}
                </option>
              }
            </select>
          </div>
          @if (filterTypes$ | async; as filterTypes) {
            <div class="col-lg-auto col-md-12 g-2">
              <select
                type="text"
                class="form-select form-select-sm me-2"
                name="filterType"
                placeholder="Select Field"
                data-cy="filterType"
                formControlName="filterType">
                @for (type of filterTypes; track type) {
                  <option
                    [attr.data-cy]="type.label"
                    [ngValue]="type.value"
                    [selected]="type.value === filterType"
                    [hidden]="type.disabled"
                    [disabled]="type.disabled">
                    {{ type.label }}
                  </option>
                }
              </select>
            </div>
          }
          <div class="d-flex col-lg-auto col-md-12 g-2 align-items-baseline">
            <mypayter-portal-filter-value-form
              class="me-1"
              formControlName="filterValue"
              [filterType$]="activeFilterType$">
            </mypayter-portal-filter-value-form>
            <span class="d-flex w-25 col-md-auto p-0 add-filter-section">
              <button
                class="btn btn-sm btn-primary mx-1"
                (click)="onAddFilter()"
                (keydown.enter)="onAddFilter()"
                data-cy="add-filter-button"
                [disabled]="!form.valid">
                Add
              </button>
              @if (!form.valid && form.dirty) {
                <small
                  class="text-danger g-0"
                  placement="top"
                  [ngbTooltip]="form.get('filterValue')?.errors?.error"
                  >&#9432;</small
                >
              }
            </span>
          </div>
        </div>
      </div>
    }

    @if (options.sortFields?.length > 0) {
      <div class="col-auto">
        <div class="row col-lg-auto">
          <div class="col-md-auto col-10 g-2">
            <select
              type="text"
              class="form-select form-select-sm me-2"
              name="sortField"
              placeholder="Select Filter"
              formControlName="sortField"
              [compareWith]="fieldCompare">
              @for (fld of options.sortFields; track fld) {
                <option [ngValue]="fld">{{ fld.label }}</option>
              }
            </select>
          </div>
          <div class="col-md-auto col-2 gx-1 gy-2">
            <button
              class="btn btn-sm btn-primary me-2"
              [attr.data-cy]="'sort-items'"
              (click)="onToggleSort()"
              (keydown.enter)="onToggleSort()">
              <i
                class="fa"
                [ngClass]="
                  sortAscending ? 'fa-sort-alpha-asc' : 'fa-sort-alpha-desc'
                "></i>
            </button>
          </div>
        </div>
      </div>
    }

    @if (showFilterSearchField) {
      <div class="col-auto flex-end fixed-height">
        <div class="col-md-auto col-8 g-2">
          <label class="visually-hidden" for="inlineFormInputName2"
            >Search</label
          >
          <input
            type="text"
            class="form-control form-control-sm me-4"
            name="searchValue"
            placeholder="Type to search..."
            formControlName="search" />
        </div>
      </div>
    }
    <div class="col-auto button-section">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        (click)="onToggleAdvanced()"
        (keydown.enter)="onToggleAdvanced()">
        <i class="fa fa-search-plus">&nbsp;</i>Advanced
      </button>
    </div>
  </div>
</form>

<div class="row" [hidden]="!isAdvanced">
  <form class="col-12" [formGroup]="advancedForm">
    <div class="mb-3 row" style="width: 600px">
      <div class="col-8">
        <textarea
          class="form-control"
          placeholder="Enter a lucene query"
          name="query"
          formControlName="advanced"></textarea>
      </div>
      <div class="col-4 g-0">
        <button
          class="btn btn-sm btn-primary me-2"
          [disabled]="advancedForm.invalid"
          (click)="onAdvancedSearch()"
          (keydown.enter)="onAdvancedSearch()">
          <i class="fa fa-search"></i>
        </button>
        <button
          class="btn btn-outline-primary btn-sm"
          (click)="onToggleAdvanced()"
          (keydown.enter)="onToggleAdvanced()">
          <i class="fa fa-search-minus">&nbsp;</i>Basic
        </button>
      </div>
    </div>
  </form>
</div>

<div class="row result-row align-items-center">
  @if (total | async; as total_count) {
    <div class="col-auto">
      <strong class="list-results"
        >Results:
        @if (visibleItems) {
          <span class="list-loaded-results"> {{ visibleItems }} of </span>
        }
        <span class="list-total-results">
          {{ total_count }}{{ total_count == 10000 ? '+' : '' }}</span
        ></strong
      >
    </div>
  }

  @if (isSelectable && checked?.length > 0) {
    <div class="col-auto">
      <strong class="list-selected-results"
        >Selected:
        <span class="list-selected-loaded-results">{{ checked?.length }} </span>
        of <span class="list-selected-total-results">{{ visibleItems }}</span>
      </strong>
    </div>
  }

  @if (filters.length > 0 && !isAdvanced) {
    <div class="row col-auto">
      <!-- [ngClass]="flt.custom ? 'bg-secondary' : 'bg-primary'" -->
      @for (flt of filters; track trackByFn(i, flt); let i = $index) {
        <span class="badge bg-filter rounded-pill col-auto mx-1 bg-primary"
          >{{ isNegative(flt) ? 'NOT ' : '' }}{{ flt.field.label }}
          @if (!flt.custom) {
            : {{ getPillValue(flt) }}
          }
          @if (!flt.notRemovable) {
            <i
              class="fa fa-remove"
              (click)="onRemoveFilterByFilterType(flt)"
              (keydown.enter)="onRemoveFilterByFilterType(flt)"></i>
          }
        </span>
      }
      <button
        class="col-2 btn btn-link btn-sm pt-0 link-offset-2"
        (click)="onResetFilter()"
        (keydown.enter)="onResetFilter()">
        Clear All Filters
      </button>
    </div>
  }
</div>

@if (hasInvalidInput) {
  <div class="row">
    <div class="col-auto invalid-input">
      <strong> {{ invalidInputString }}</strong>
    </div>
  </div>
}
